module.exports = __webpack_public_path__ + "assets/img/18.1e7a5849.png";